module.exports = __webpack_public_path__ + "static/media/IMG_0098.f5788eef.jpg";